// Wording for the organizer add-player 403. The Leagues API guard
// (TeamMemberManager.EnsureOrganizerCanAddToTeamAsync) throws ForbiddenException with no
// DisplayMessage when the caller is outside the leagues_organizer_direct_add allowlist, so the
// client has to supply the explanation itself (ENG-2663).
export const ADD_PLAYER_NOT_ENABLED_MESSAGE =
    'Your account is not enabled for adding players directly. Contact UTR support if you need access.';

// Decides how an add-player failure should be surfaced.
//
// Returns the message to render inline in the modal, or null when the error is not one the modal
// can explain — the caller then falls through to the global error popup. Both add endpoints share
// the same guard, so both can answer 403 (not on the allowlist) and 400 (session already ended).
export const getAddPlayerWarningMessage = (error, fallbackMessage) => {
    const status = error?.status;

    if (status === 403) {
        return error?.message || ADD_PLAYER_NOT_ENABLED_MESSAGE;
    }

    if (status === 400) {
        return error?.message || fallbackMessage;
    }

    return null;
};
